import { IVisaPrepForm } from '../../../../../../types';

type Fields = Pick<IVisaPrepForm, 'hasTravelled' | 'travelItems'>;

type Params = Fields;

export function getPageStatus({ hasTravelled, travelItems }: Params): { complete: boolean } {
  let complete = true;
  if (hasTravelled === undefined) {
    complete = false;
  }
  if (hasTravelled === true) {
    if (!travelItems || travelItems.length === 0) {
      complete = false;
    } else {
      complete = !travelItems.some(travel => {
        return (
          travel.country === '' ||
          travel.reason === '' ||
          (travel.reason === 'Other - provide details' && travel.reasonOther === '') ||
          travel.entryDate === '' ||
          travel.exitDate === ''
        );
      });
    }
  }

  return { complete };
}
